export type AssetScanKey = { assetId: string; assetTag?: never } | { assetTag: string; assetId?: never };

/** UUID-shaped tags are IDs; lookups must never fall back after failure. */
export function classifyAssetKey(key: string): AssetScanKey | null {
  if (key !== key.trim()) return null;
  if (/^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(key)) return { assetId: key };
  if (/^[A-Z0-9-]{3,60}$/.test(key)) return { assetTag: key };
  return null;
}

/** Accept only our exact label route or a bare identifier, not arbitrary navigable URLs. */
export function parseAssetScan(input: string, origin: string): AssetScanKey | null {
  const bare = classifyAssetKey(input);
  if (bare) return bare;
  if (input.startsWith('/a/')) return classifyAssetKey(input.slice(3));
  if (input !== input.trim()) return null;
  const match = /^https?:\/\/[^\s/?#@]+\/a\/([^/?#]+)$/.exec(input);
  if (!match) return null;
  try {
    const url = new URL(input);
    if (url.origin !== origin || url.username || url.password || url.pathname !== `/a/${match[1]}`) return null;
    return classifyAssetKey(match[1]!);
  } catch { return null; }
}
